module.exports = __webpack_public_path__ + "static/media/pluto.636c1636.png";